export function getStorage(key) {
  const keyNormalized = Array.isArray(key) ? key : [key]
  return new Promise(resolve => {
    window.chrome?.storage?.local?.get(keyNormalized, result => resolve(result))
  })
}

export function setStorage(data) {
  return new Promise(resolve => {
    return window.chrome?.storage?.local?.set(data, result => resolve(result))
  })
}

export function removeFromStorage(...keys) {
  return new Promise(resolve => {
    return window.chrome?.storage?.local?.remove(keys, result =>
      resolve(result)
    )
  })
}
